import {createMemoryHistory, createRouter} from 'vue-router'
import common from "@/common";

const router = createRouter({
    routes: [
        {
            path: '/',
            redirect: () => {
                let urlParam = common.getRequest();
                //url参数中包含errCode则跳转到错误页面
                if (urlParam.errCode) {
                    return '/error';
                }
                //url参数中的action为绑定手机号/修改手机号/修改密码时跳转到单独页面
                switch (urlParam.action) {
                    case 'phone': // 绑定手机号
                    case 'changePhone': // 修改手机号
                    case 'changePwd': // 修改密码
                        return '/full-other';
                    case 'device': // 设备管理
                        return '/device';
                    default:
                        return '/login';
                }
            },
            component: () => import('@/layouts/FullScreenLayout'),
            children: [
                {path: 'login', component: () => import('@/views/LoginView')},
                {path: 'error', component: () => import('@/views/ErrorView')},
                {path: 'full-other', component: () => import('@/views/FullView')},
                {path: 'device', component: () => import('@/views/DeviceView')},
            ]
        },
    ],
    history: createMemoryHistory(),
});

export default router;